import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/src/app/layout.js");
